import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { CONSTANT } from "../../utils/Constants";

export interface DefaultProjectVehicle {
  content: string;
  // Remitente de la carta; {proyecto} se reemplaza por el nombre del proyecto.
  senderContent?: string | null;
  // Firmas de la carta, una por línea.
  signatureContent?: string | null;
  lastModifiedBy?: string | null;
  lastModifiedDate?: string | number[] | null;
}

// Datos por defecto de la lista de personal (vehículos, remitente y firmas) que
// se copian a cada proyecto cuando se siembran sus datos por defecto (PROJECTS_API).
export const getDefaultProjectVehicle =
  async (): Promise<DefaultProjectVehicle> => {
    const response = await privateFetch.get(URL.REQUEST_DEFAULT_PROJECT_VEHICLE);
    return response.data;
  };

export const saveDefaultProjectVehicle = async (
  content: string,
  senderContent: string,
  signatureContent: string,
  user: string
): Promise<DefaultProjectVehicle> => {
  const response = await privateFetch.put(
    URL.REQUEST_DEFAULT_PROJECT_VEHICLE,
    JSON.stringify({ content, senderContent, signatureContent, user }),
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
  return response.data;
};
